import store from '@/store'

export default function unauthorized() {
  store.dispatch('user/logout')
  setTimeout(()=>{window.location.reload()},100)
}